import type { MarketplaceUploadImageItem } from '../hooks/useMarketplaceImageUpload';

type ProgramImageItem = {
  uid: string;
};

interface FailedUpload {
  item: MarketplaceUploadImageItem;
  error: unknown;
  arrayItemUid?: string;
}

interface HandleMarketplaceUploadFailuresParams {
  failedUploads: FailedUpload[];
  notifyImageError: (label: string) => void;
  getProgramImages: () => ProgramImageItem[];
  setProgramImages: (images: ProgramImageItem[]) => void;
  resetImageField: (fieldName: string) => void;
}

export function handleMarketplaceUploadFailures({
  failedUploads,
  notifyImageError,
  getProgramImages,
  setProgramImages,
  resetImageField,
}: HandleMarketplaceUploadFailuresParams): void {
  failedUploads.forEach(({ item }) => {
    notifyImageError(item.label);

    if (item.arrayItemUid) {
      const currentImages = getProgramImages();

      setProgramImages(
        currentImages.filter(image => image.uid !== item.arrayItemUid)
      );

      return;
    }

    resetImageField(item.formFieldPath);
  });
}
